<template>
  <v-container>
    <question-navigator v-if="cookieIsSet"></question-navigator>
  </v-container>
</template>

<script>
import QuestionNavigator from "@/components/question/QuestionNavigator.vue";

export default {
  name: "question-controller",
  components: {QuestionNavigator},
  data() {
    return {
      cookieIsSet: true,
    }
  },
}
</script>
